/**
 * Extracts the domain part of an email address for use as an eTracker
 * dimension value, e.g. "felix@schako.com" -> "schako.com".
 * Returns undefined when there is no usable domain, so callers can skip the
 * slot instead of sending an empty value.
 */
export function emailDomain(email: string | undefined): string | undefined {
  const normalized = email?.trim().toLowerCase()
  const domain = normalized?.split("@").pop()

  // Without an "@" split().pop() returns the input unchanged; with a trailing
  // "@" it returns an empty string. Both mean there is no domain to report.
  return domain && domain !== normalized ? domain : undefined
}
